// extracted by mini-css-extract-plugin
module.exports = {"filtersPanel":"WithFilter_filtersPanel__k3l4e","hide":"WithFilter_hide__qo7U9","wrapper":"WithFilter_wrapper__VqTS_","results":"WithFilter_results__qUCa7"};